import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import {
  useNavigate,
  useSearchParams,
  Link as RouterLink,
} from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import axios from "axios";

import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import config from "../../Config";
import { attachMarketingUser } from "../../utils/marketingAttribution";
import PopUp from "../Pop-up/pop-up";
import { GoogleLogin } from "@react-oauth/google";
import { handleGoogleBrowserLogin } from "../../utils/googleLogin";
import AssetConfig from "../../Theme/Assest";
export default function RegistrationPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isPhoneSignUp, setIsPhoneSignUp] = useState(true);
  const [isEmailSignUp, setIsEmailSignUp] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showSigninPopup, setShowSigninPopup] = useState(false);
  const [popupContact, setPopupContact] = useState("");
  const [popupEmail, setPopupEmail] = useState("");

  useEffect(() => {
    const contact = searchParams.get("contact");
    const emailParam = searchParams.get("email");

    if (contact) {
      setPhoneNumber(contact.replace(/\D/g, "").slice(0, 10));
      setIsPhoneSignUp(true);
      setIsEmailSignUp(false);
    } else if (emailParam) {
      setEmail(emailParam);
      setIsPhoneSignUp(false);
      setIsEmailSignUp(true);
    }
  }, [searchParams]);

  const handlePhoneSignUp = () => {
    setIsPhoneSignUp(true);
    setIsEmailSignUp(false);
    setIsOtpSent(false);
    setOtp("");
    setError("");
  };

  const handleEmailSignUp = () => {
    setIsEmailSignUp(true);
    setIsPhoneSignUp(false);
    setIsOtpSent(false);
    setOtp("");
    setError("");
  };

  const openSigninPopup = (contact, emailValue) => {
    setPopupContact(contact || "");
    setPopupEmail(emailValue || "");
    setShowSigninPopup(true);
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    if (loading) return;

    if (!credentialResponse?.credential) {
      setError("Google authentication failed. Please try again.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await handleGoogleBrowserLogin({
        credential: credentialResponse.credential,

        onSuccess: () => {
          navigate("/");
        },

        onError: (message) => {
          setError(message);
        },
      });
    } catch (error) {
      console.error("Google registration error:", error);
      setError("Google registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoToSignIn = () => {
    const query = isPhoneSignUp
      ? `?contact=${encodeURIComponent(popupContact)}`
      : `?email=${encodeURIComponent(popupEmail)}`;

    navigate(`/Signin${query}`);
  };

  const handleGetOtp = async () => {
    if (loading) return;

    setError("");
    const cleanPhone = phoneNumber.replace(/\D/g, "");
    const emailValue = email.trim();

    if (isPhoneSignUp && cleanPhone.length !== 10) {
      setError("Please enter a valid 10-digit phone number.");
      return;
    }

    if (
      isEmailSignUp &&
      (!emailValue || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailValue))
    ) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);

      const endpoint = isPhoneSignUp
        ? "/user/mobileSignupOtp"
        : "/user/emailSignupOtp";

      const payload = isPhoneSignUp
        ? { contact: cleanPhone }
        : { email: emailValue };

      await axios.post(`${config.apiBaseUrl}${endpoint}`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (isPhoneSignUp) setPhoneNumber(cleanPhone);
      if (isEmailSignUp) setEmail(emailValue);

      setIsOtpSent(true);
      setOtp("");
    } catch (err) {
      const status = err.response?.status;
      const message = String(err.response?.data?.message || "");

      const alreadyExists =
        status === 422 ||
        /contact already exist|email already exist|already exists/i.test(
          message,
        );

      if (alreadyExists) {
        openSigninPopup(
          isPhoneSignUp ? cleanPhone : "",
          isEmailSignUp ? emailValue : "",
        );
        return;
      }

      setError(
        message || "There was an issue sending the OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitOtp = async () => {
    if (loading) return;

    setError("");

    if (!otp.trim()) {
      setError("Please enter the OTP.");
      return;
    }

    if (otp.trim().length < 4) {
      setError("Please enter a valid OTP.");
      return;
    }

    const signUpData = isEmailSignUp
      ? { email: email.trim(), otp: otp.trim() }
      : { contact: phoneNumber.replace(/\D/g, ""), otp: otp.trim() };

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseUrl}/${config.userSignIn}`,
        signUpData,
        { headers: { "Content-Type": "application/json" } },
      );

      if (response.status !== 200) {
        setError(response.data?.message || "Unable to complete registration.");
        return;
      }

      const data = response.data || {};
      const userId =
        data.userId ||
        data.userData?.userId ||
        data.UserData?.userId ||
        data.userDoc?.userId;

      const newToken =
        data.newToken || data.userData?.newToken || data.UserData?.newToken;

      const userEmail =
        data.email ||
        data.userData?.email ||
        data.UserData?.email ||
        data.userDoc?.email ||
        (isEmailSignUp ? email.trim() : null);

      const userContact =
        data.contact ||
        data.userData?.contact ||
        data.UserData?.contact ||
        data.userDoc?.contact ||
        (isPhoneSignUp ? phoneNumber.replace(/\D/g, "") : null);

      if (userId) sessionStorage.setItem("userId", userId);
      if (newToken) sessionStorage.setItem("newToken", newToken);
      if (userEmail) sessionStorage.setItem("userEmail", userEmail);
      if (userContact) sessionStorage.setItem("userContact", userContact);

      if (userId) {
        await attachMarketingUser({
          userId,
          email: userEmail,
          contact: userContact,
        });
      }

      navigate("/");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Unable to verify OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChangeMethod = () => {
    setIsOtpSent(false);
    setOtp("");
    setError("");
  };

  const currentMethod = isPhoneSignUp ? "phone" : "email";

  const fieldSx = {
    "& .MuiOutlinedInput-root": {
      height: 54,
      borderRadius: 0,
      background: "#fff",
      "& fieldset": { borderColor: "#d8d2c9" },
      "&:hover fieldset": { borderColor: "#977743" },
      "&.Mui-focused fieldset": {
        borderColor: "#171717",
        borderWidth: 1,
      },
    },
    "& input": { fontSize: 13 },
  };

  const buttonSx = {
    height: 54,
    borderRadius: 0,
    background: "#171717",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    boxShadow: "none",
    "&:hover": { background: "#977743", boxShadow: "none" },
    "&:disabled": { background: "#302f2d", color: "#fff" },
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f7f4ef",
        color: "#171717",
      }}
    >
      <Navbar />

      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          py: { xs: 5, sm: 7, md: 9 },
          px: { xs: 2, sm: 3 },
        }}
      >
        <Container maxWidth="sm" sx={{ px: { xs: 0, sm: 2 } }}>
          <Box
            sx={{
              width: "100%",
              background: "#fff",
              border: "1px solid #ddd7ce",
              px: { xs: 2.5, sm: 5, md: 6 },
              py: { xs: 3.5, sm: 5, md: 5.5 },
              boxShadow: "0 18px 60px rgba(23,23,23,0.06)",
            }}
          >
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <Box
                sx={{
                  width: 85,
                  height: 85,
                  mx: "auto",
                  mb: 2.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f7f4ef",
                  border: "1px solid #ddd7ce",
                }}
              >
                <Box
                  component="img"
                  src={AssetConfig.logoLight}
                  alt="Hindustan Wardrobe"
                  sx={{ width: 85, height: 85, objectFit: "contain" }}
                />
              </Box>

              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1.2}
                sx={{ mb: 1 }}
              >
                <Box sx={{ width: 25, height: 1, background: "#977743" }} />
                <Typography
                  sx={{
                    fontSize: 8,
                    fontWeight: 700,
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    color: "#977743",
                  }}
                >
                  Hindustan Wardrobe
                </Typography>
                <Box sx={{ width: 25, height: 1, background: "#977743" }} />
              </Stack>

              <Typography
                component="h1"
                sx={{
                  fontFamily: "Georgia, serif",
                  fontSize: { xs: 32, sm: 38, md: 42 },
                  fontWeight: 400,
                  lineHeight: 1.1,
                  letterSpacing: "-0.035em",
                }}
              >
                Create an account
              </Typography>

              <Typography
                sx={{
                  mt: 1.3,
                  color: "#77716a",
                  fontSize: 12,
                  lineHeight: 1.7,
                }}
              >
                Join our wardrobe community and discover pieces worth wearing.
              </Typography>
            </Box>

            <Stack spacing={1.5}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  "& > div": {
                    width: "100%",
                  },
                }}
              >
                <GoogleLogin
                  onSuccess={handleGoogleSuccess}
                  onError={() => {
                    setError("Google registration failed. Please try again.");
                  }}
                  useOneTap={false}
                  theme="outline"
                  shape="rectangular"
                  size="large"
                  text="continue_with"
                  width="100%"
                />
              </Box>

              <Button
                fullWidth
                variant="outlined"
                startIcon={
                  currentMethod === "phone" ? (
                    <EmailOutlinedIcon sx={{ fontSize: 18 }} />
                  ) : (
                    <PhoneOutlinedIcon sx={{ fontSize: 18 }} />
                  )
                }
                onClick={
                  currentMethod === "phone"
                    ? handleEmailSignUp
                    : handlePhoneSignUp
                }
                sx={{
                  height: 50,
                  borderRadius: 0,
                  borderColor: "#d8d2c9",
                  color: "#171717",
                  background: "#fff",
                  fontSize: 10,
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  "&:hover": { borderColor: "#171717", background: "#faf8f5" },
                }}
              >
                {currentMethod === "phone"
                  ? "Continue with Email"
                  : "Continue with Phone"}
              </Button>
            </Stack>

            <Divider
              sx={{
                my: 3.5,
                borderColor: "#e5e0d8",
                "&::before, &::after": { borderColor: "#e5e0d8" },
              }}
            >
              <Typography
                sx={{
                  px: 1,
                  fontSize: 9,
                  fontWeight: 700,
                  letterSpacing: "0.16em",
                  color: "#99938b",
                }}
              >
                OR
              </Typography>
            </Divider>

            {!isOtpSent ? (
              <>
                <Box sx={{ mb: 2.5 }}>
                  <Typography
                    sx={{
                      mb: 1,
                      fontSize: 10,
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      color: "#4e4a45",
                    }}
                  >
                    {isPhoneSignUp ? "Mobile Number" : "Email Address"}
                  </Typography>

                  {isPhoneSignUp ? (
                    <TextField
                      fullWidth
                      placeholder="Enter your 10-digit number"
                      type="tel"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(
                          e.target.value.replace(/\D/g, "").slice(0, 10),
                        );
                        setError("");
                      }}
                      InputProps={{
                        startAdornment: (
                          <Typography
                            sx={{ mr: 1, color: "#77716a", fontSize: 14 }}
                          >
                            +91
                          </Typography>
                        ),
                      }}
                      sx={fieldSx}
                    />
                  ) : (
                    <TextField
                      fullWidth
                      placeholder="Enter your email address"
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError("");
                      }}
                      sx={fieldSx}
                    />
                  )}

                  {error && (
                    <Typography
                      sx={{
                        mt: 1.2,
                        fontSize: 11,
                        lineHeight: 1.5,
                        color: "#a33b32",
                      }}
                    >
                      {error}
                    </Typography>
                  )}
                </Box>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleGetOtp}
                  disabled={loading}
                  sx={buttonSx}
                >
                  {loading ? (
                    <PropagateLoader color="#fff" size={7} />
                  ) : (
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                      spacing={1}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontSize: 10,
                          fontWeight: 700,
                          letterSpacing: "0.16em",
                        }}
                      >
                        Get OTP
                      </Typography>
                      <ArrowForwardRoundedIcon sx={{ fontSize: 16 }} />
                    </Stack>
                  )}
                </Button>
              </>
            ) : (
              <>
                <Box sx={{ textAlign: "center", mb: 3 }}>
                  <Typography
                    sx={{
                      fontSize: 9,
                      fontWeight: 700,
                      letterSpacing: "0.18em",
                      textTransform: "uppercase",
                      color: "#977743",
                      mb: 1,
                    }}
                  >
                    Verification
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Georgia, serif",
                      fontSize: 27,
                      fontWeight: 400,
                    }}
                  >
                    Verify your details
                  </Typography>
                  <Typography
                    sx={{
                      mt: 1,
                      fontSize: 11,
                      color: "#77716a",
                      lineHeight: 1.7,
                    }}
                  >
                    We sent a verification code to your{" "}
                    {isPhoneSignUp ? "mobile number" : "email address"}.
                  </Typography>
                </Box>

                <TextField
                  fullWidth
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={(e) => {
                    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6));
                    setError("");
                  }}
                  inputProps={{ maxLength: 6, inputMode: "numeric" }}
                  sx={{
                    ...fieldSx,
                    "& .MuiOutlinedInput-root": {
                      ...fieldSx["& .MuiOutlinedInput-root"],
                      height: 58,
                    },
                    "& input": {
                      textAlign: "center",
                      letterSpacing: "0.45em",
                      fontSize: 18,
                      fontWeight: 600,
                    },
                  }}
                />

                {error && (
                  <Typography
                    sx={{
                      mt: 1.2,
                      fontSize: 11,
                      lineHeight: 1.5,
                      color: "#a33b32",
                      textAlign: "center",
                    }}
                  >
                    {error}
                  </Typography>
                )}

                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleSubmitOtp}
                  disabled={loading}
                  sx={{ ...buttonSx, mt: 2 }}
                >
                  {loading ? (
                    <PropagateLoader color="#fff" size={7} />
                  ) : (
                    "Verify & Continue"
                  )}
                </Button>

                <Button
                  fullWidth
                  variant="text"
                  onClick={handleChangeMethod}
                  startIcon={<ArrowBackRoundedIcon sx={{ fontSize: 15 }} />}
                  sx={{
                    mt: 1,
                    height: 42,
                    borderRadius: 0,
                    color: "#77716a",
                    fontSize: 9,
                    fontWeight: 700,
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    "&:hover": { background: "#f7f4ef", color: "#171717" },
                  }}
                >
                  Change details
                </Button>
              </>
            )}

            <Box
              sx={{
                mt: 4,
                pt: 3,
                borderTop: "1px solid #eee9e2",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 11, color: "#77716a" }}>
                Already have an account?{" "}
                <Link
                  href="/Signin"
                  underline="none"
                  sx={{
                    color: "#171717",
                    fontWeight: 700,
                    "&:hover": { color: "#977743" },
                  }}
                >
                  Sign in
                </Link>
              </Typography>
            </Box>

            <Typography
              sx={{
                mt: 3,
                textAlign: "center",
                fontSize: 8,
                lineHeight: 1.7,
                color: "#aaa39a",
                letterSpacing: "0.04em",
              }}
            >
              By continuing, you agree to our{" "}
              <RouterLink
                to="/TermsConditions/1"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                terms
              </RouterLink>{" "}
              and{" "}
              <RouterLink
                to="/privacy/1"
                style={{ color: "inherit", textDecoration: "underline" }}
              >
                privacy policy
              </RouterLink>
              .
            </Typography>
          </Box>
        </Container>
      </Box>

      <Footer />

      <PopUp
        open={showSigninPopup}
        setOpen={setShowSigninPopup}
        title="Already have an account?"
        description={
          isPhoneSignUp
            ? "This mobile number is already registered. Would you like to sign in instead?"
            : "This email address is already registered. Would you like to sign in instead?"
        }
        primaryText="Sign In"
        secondaryText="Cancel"
        onPrimary={handleGoToSignIn}
      />
    </Box>
  );
}
